import React from 'react';

// New UI only (docs/ui_redesign/18-ux-review.md, R15): dates read MM/DD/YYYY everywhere, like the editor, and a
// date-only value doesn't show a midnight time ("9/26/2026, 12:00:00 AM" reads 09/26/2026). Display only: sorting,
// filtering and CSV export keep Classic's values.
const pad = n => String(n).padStart(2, '0');
const MIDNIGHT = /^12:00(:00)?\s?AM$/i;

export function formatDateText(v) {
	if (typeof v !== 'string') return v;
	const s = v.trim();
	let m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:,?\s+(\d{1,2}:\d{2}(?::\d{2})?\s?[AP]M))?$/i);
	if (m) {
		const date = `${pad(m[1])}/${pad(m[2])}/${m[3]}`;
		return m[4] && !MIDNIGHT.test(m[4].replace(/\s+/g, ' ')) ? `${date}, ${m[4]}` : date;
	}
	m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?Z?)?$/);
	if (m && (!m[4] || (m[4] === '00' && m[5] === '00' && (!m[6] || m[6] === '00')))) return `${m[2]}/${m[3]}/${m[1]}`;
	return v;
}

// A date column shows its value through formatDateText: its own renderCell's text output, or the formatted value.
export function withDateFormat(c) {
	if (!c || !/date|time/i.test(c.field || '') || c.type === 'actions' || c.apw2Dates) return c;
	const own = c.renderCell;
	return {
		...c, apw2Dates: true,
		renderCell: own
			? p => { const out = own(p); return typeof out === 'string' ? formatDateText(out) : out; }
			: p => { const t = formatDateText(p.formattedValue != null ? p.formattedValue : p.value); return t == null || t === '' ? t : <div className="MuiDataGrid-cellContent" title={String(t)}>{t}</div>; }
	};
}
export const datedColumns = columns => (Array.isArray(columns) ? columns.map(withDateFormat) : columns);
